import _ from 'underscore';

angular.module('am4')
.factory('workoutDataService', function($http, $q, $translate, $filter, appCacheService, apiUrl) {
    var seriesName = $filter('seriesName');

    return {
        getWorkoutData: function(type, query) {
            var dataStore = appCacheService.getAppCache('workoutDataStore');

            // if there is an existing query setting that isn't the same as the function argument,
            // reset dataStore (because we would have to refetch the data for the new query), and store the
            // new query in dataStore
            if (_.isUndefined(dataStore.query) || !angular.equals(dataStore.query, query)) {
                dataStore = {};
                dataStore.query = angular.copy(query);
            }
            // If we don't already have the data for a type, store the promise that will resolve
            if (_.isUndefined(dataStore[type])) {
                dataStore[type] = $http.post(apiUrl + '/workouts/' + type, dataStore.query)
                .then(function(res) {
                    // We get an 200 OK with body {errorMessage: 'Task timed out after 10.00 seconds'} in some cases...
                    if (res.data.errorMessage) {
                        return $q.reject(res.data);
                    }

                    // Service has no data for us
                    if (res.data.length === 0) {
                        return $q.reject(res.data);
                    }

                    for (var i = 0; i < res.data.length; i++) {
                        let group = res.data[i].group;

                        if (group.series) {
                            group.raw_series = group.series;
                            group.series = seriesName(group.series);
                        }
                        if (group.machine_type_code) {
                            group.raw_machine_type_code = group.machine_type_code;
                            group.machine_type_code = $translate.instant(group.machine_type_code.toUpperCase().replaceAll(' ', '_'));
                        }
                    }
                    return res.data;
                })
                .catch(function(res) {
                    // intercept to remove cache
                    dataStore = {};

                    return $q.reject(res);
                });
            }

            appCacheService.setAppCache('workoutDataStore', dataStore);

            return dataStore[type];
        },
        convertWorkoutDataToPapaTabular: function(res) {
            var ret = {
                fields: [],
                data: []
            };

            // Add column headers
            ret.fields.push($translate.instant('TIME'));

            for (let i = 0; i < res.length; i++) {
                let headerName = [];
                for (let prop in res[i].group) {
                    if (res[i].group.hasOwnProperty( prop )) {
                        headerName.push(res[i].group[prop]);
                    }
                }
                ret.fields.push(headerName.join(', '));
            }


            // Loop through y axis
            for (let i = 0; i < res[0].data.length; i++) {
                let row = [];

                // Add time data point
                row.push(res[0].data[i].x);

                // Add other data points
                for (let j = 0; j < res.length; j++) {
                    row.push((res[j].data[i] || {}).y);
                }

                ret.data.push(row);
            }

            return ret;
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/services/workoutData.js